import { LoadingStatusType } from "@/enums/enums";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/index";
import { i18n } from "@/i18n";
import { ToAccountList } from "@/service/account/accountFacade";

@Module({ namespaced: true })
export default class Account extends VuexModule {
  public accountList: any = [];
  public accountListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getAccountList(): any {
    return this.accountList;
  }

  get getAccountListLoadingStatus(): any {
    return this.accountListLoadingStatus;
  }

  @Mutation
  public MutationSetAccountListLoadingStatus(status: LoadingStatusType) {
    this.accountListLoadingStatus = status;
  }

  @Mutation
  public MutationAccountList(accountList: any) {
    this.accountList = accountList;
  }

  @Action
  public DoGetAllMainAccount() {
    if (this.accountListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAccountListLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoGetAllMainAccount().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const accountList = ToAccountList(res.data.accountList, i18n.locale);
          this.context.commit("MutationAccountList", accountList);
        }
        this.context.commit("MutationSetAccountListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
